import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import classnames from "classnames";
import FormLinkButton_styles from "./FormLinkButton.styles.js";
const FormLinkButton = (t0)=>{
    const $ = c(6);
    const { children, variant: t1 } = t0;
    const variant = void 0 === t1 ? "primary" : t1;
    const { classes } = FormLinkButton_styles();
    const t2 = "tertiary" === variant && classes.linkButton_tertiary;
    let t3;
    if ($[0] !== classes.linkButton || $[1] !== t2) {
        t3 = classnames(classes.linkButton, t2);
        $[0] = classes.linkButton;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== children || $[4] !== t3) {
        t4 = /*#__PURE__*/ jsx("button", {
            type: "submit",
            className: t3,
            children: children
        });
        $[3] = children;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
};
export { FormLinkButton };
